import { Injectable } from '@angular/core';
import { AssessmentPayload, IDetails, IMarketing, IResponse } from '@interfaces/index';
import { HttpService } from '@ui-components/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RespectService {
  private readonly API_BASE = 'assessments';
  private readonly USERS_API = 'users';

  constructor(private _http_service: HttpService) { }

  fetchAssessmentDetails(token: string): Observable<IResponse<{ assessment: IDetails; type: string }>> {
    return this._http_service.post(`${this.API_BASE}/get-details`, { id: token });
  }

  registerMarketingUser(payload: AssessmentPayload): Observable<IResponse<IMarketing>> {
    return this._http_service.post(`${this.USERS_API}/create-marketing-user`, payload);
  }

  startAssessmentWithInvite(payload: AssessmentPayload): Observable<IResponse<{ access_token: string }>> {
    return this._http_service.post(`${this.API_BASE}/start-invite-assessment`, payload);
  }
}
